module.exports = __webpack_public_path__ + "static/Cameron Nuckols-af97706f9364789efa03c69237fde608.png";